import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Form, notification } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';

import ProgramForm from '@/components/ProgramForm';
import { programLabels } from '@/config';
import useGlobalConfig from '@/store/global';

import CentralBillingOnly from './programs/components/CentralBillingOnly';
import ReimbursementAddress from './programs/components/ReimbursementAddress';

const disabledFields = [
  'patient_first_name',
  'patient_last_name',
  'date_of_birth',
  'patient_gender_code',
];

const AssistanceRequestFormEdit = () => {
  const themeColor = localStorage.getItem('themeColor');
  const { program } = useGlobalConfig();
  const [form] = Form.useForm();
  const { assistanceRequestId } = useParams();
  const [icdCodeNames, setIcdCodeNames] = useState([]);
  const [meData, setMeData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [notificationApi, notificationContextHolder] = notification.useNotification();

  const loadData = async () => {
    const { data } = await axios.get('programs/icd_code_names');
    setIcdCodeNames(data);
  };

  const loadMeData = async () => {
    const { data } = await axios.get('sessions/me');
    setMeData(data);
  };

  const loadAssistanceRequestData = async () => {
    const { data } = await axios.get(`assistance_requests/${assistanceRequestId}`);
    form.setFieldsValue(data);
    form.setFieldValue('expected_dispensing_date', dayjs(data.expected_dispensing_date));
    form.setFieldValue('date_of_birth', dayjs(data.date_of_birth));
    form.setFieldValue('date_prescription_written', dayjs(data.date_prescription_written));
  };

  let renderRef = useRef(false);

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false;
      return;
    }
    loadData();
    loadAssistanceRequestData();
    loadMeData();
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);

      const { data } = await axios.put(
        `assistance_requests/${assistanceRequestId}`,
        {
          ...values,
          date_of_birth: dayjs(values.date_of_birth).format('YYYY-MM-DD'),
          date_prescription_written: dayjs(values.date_prescription_written).format('YYYY-MM-DD'),
          expected_dispensing_date: dayjs(values.expected_dispensing_date).format('YYYY-MM-DD'),
        },
        {
          customError: true,
        }
      );
      console.log('response: ', data);

      navigate(-1);
    } catch (e: any) {
      const errorMessage = e?.data?.message?.split('\n')?.[0] || e?.data?.message;
      notificationApi.error({
        message: errorMessage,
        duration: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {notificationContextHolder}
      <div className="max-w-screen-xl mx-auto">
        <h1 className="mb-4 text-xl md:text-2xl font-bold">{programLabels[program.name].title}</h1>

        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Card className="mb-6 bg-zinc-50">
            <ProgramForm
              programName={program.name}
              icdCodeNames={icdCodeNames}
              meData={meData}
              disabledFields={disabledFields}
            />
          </Card>

          <CentralBillingOnly meData={meData} />
          <ReimbursementAddress meData={meData} />

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 14,
            }}
          >
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              disabled={loading}
              style={{
                width: '60%',
                backgroundColor: themeColor as string,
                height: '40px',
                fontSize: '18px',
                marginTop: '20px',
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AssistanceRequestFormEdit;
